export default __webpack_public_path__ + "static/media/AkzidenzGrotesk-MediumCondAlt.f22c2543.otf";